/*
 * @Author: shuo.li
 * @Date: 2021-11-3 11:12
 * @LastEditors:
 * @LastEditTime:
 * @Description: 获取字符串宽度（区分全角半角）
 * @Input: str:String, fontSize:String
 * @Output: Number
 */
export function getTextWidth(str, fontSize = "14px") {
  let result = 10;
  const ele = document.createElement("span");
  ele.innerText = str;
  ele.style.fontSize = fontSize;
  document.documentElement.append(ele);
  result = ele.offsetWidth;
  document.documentElement.removeChild(ele);
  return result;
}
